import React from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router';
import {
  NavigationSide,
  NavigationSideItem,
  viPlaylist,
  viStation,
  viMusic,
} from 'vibeguide';

function MusicContainer({
  user,
}) {
  return (
    <div
      className="MusicContainer"
      style={{
        height: '100%',
      }}
    >
      <NavigationSide>
        <NavigationSideItem
          text="Playlists"
          url="/music/playlists"
          icon={viPlaylist}
          show={user.can('playlist.view')}
          testId="music-nav-playlists"
        />

        <NavigationSideItem
          text="Stations"
          url="/music/stations"
          icon={viStation}
          show={user.can('mix.view')}
          testId="music-nav-stations"
        />

        <NavigationSideItem
          text="Songs"
          url="/music/songs"
          icon={viMusic}
          show={user.can('music.view')}
          testId="music-nav-songs"
        />
      </NavigationSide>

      <Outlet />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(MusicContainer);
